import { DE, DOMAIN_LANGUAGE, NL } from '../../constants/browser';

const quriobotIDs = {
  [DE]: {
    loggedIn: {
      prod: '9nJaZmp23wEpvxPR/V895xbyLkKEeqZYd',
      test: '9nJaZmp23wEpvxPR/KoPqxmzDPzEg5eNl',
      dev: '9nJaZmp23wEpvxPR/wKYPWr64kBbd0px4'
    },
    loggedOut: {
      prod: '9nJaZmp23wEpvxPR/DYRAQrGeDwbW05dx',
      test: '9nJaZmp23wEpvxPR/DYRAQrGeDwbW05dx',
      dev: '9nJaZmp23wEpvxPR/DYRAQrGeDwbW05dx'
    }
  },
  [NL]: {
    loggedIn: {
      prod: '9nJaZmp23wEpvxPR/lD1XMmd24xEPVZKN',
      test: '9nJaZmp23wEpvxPR/nj7qyrYgYNbkgxzB',
      dev: '9nJaZmp23wEpvxPR/nj7qyrYgYNbkgxzB'
    },
    loggedOut: {
      prod: '9nJaZmp23wEpvxPR/PkZNLEkQYxm5XGaR',
      test: '9nJaZmp23wEpvxPR/PkZNLEkQYxm5XGaR',
      dev: '9nJaZmp23wEpvxPR/PkZNLEkQYxm5XGaR'
    }
  }
};

const liveAgentIDs = {
  [DE]: {
    prod: 'iuz8ak81',
    test: '6t8y1w3j',
    dev: '5d58z4nj'
  },
  [NL]: {
    prod: 't2kbr92b',
    test: 'bh09wfov',
    dev: 'bh09wfov'
  }
};

export const getQuriobotID = isLoggedIn => {
  const ids =
    quriobotIDs[DOMAIN_LANGUAGE][isLoggedIn ? 'loggedIn' : 'loggedOut'];

  return process.env.NODE_ENV === 'production'
    ? ids.prod
    : process.env.NODE_ENV === 'development'
    ? ids.dev
    : ids.test;
};

export const getLiveAgentId = () => {
  const ids = liveAgentIDs[DOMAIN_LANGUAGE];

  return process.env.NODE_ENV === 'production'
    ? ids.prod
    : process.env.NODE_ENV === 'development'
    ? ids.dev
    : ids.test;
};

export const liveAgentSrcUrl =
  process.env.NODE_ENV === 'production'
    ? 'https://troy.ladesk.com/scripts/track.js'
    : process.env.NODE_ENV === 'development'
    ? 'https://troy-dev.ladesk.com/scripts/track.js'
    : 'https://troy-test.ladesk.com/scripts/track.js';
